import { DataBean } from "../DataBean";

export class PaymentTurn extends DataBean {
  public async getPaymentTurnCatalog(
    year: any,
    month: any,
    idAccount: any,
    state: any,
    page: any,
    recordsPerPage: any
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.advantage.shared.Report_getPaymentTurnCatalog_Number_Number_Number_Number_Number_Number",
      [year, month, idAccount, state, page, recordsPerPage]
    );
  }

  public async addPaymentAccountToPaymentTurn(
    year: number,
    idDocument: number,
    documentDate: any,
    code: number,
    idProcedureIMP: number,
    idProcedureIMPDate: any,
    idEmployee: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "boolean_addPaymentAccountToPaymentTurn_Number_Number_java.util.Date_Number_Number_java.util.Date_Number",
      [
        year,
        idDocument,
        documentDate,
        code,
        idProcedureIMP,
        idProcedureIMPDate,
        idEmployee,
      ]
    );
  }

  public async addPaymentAccountToPaymentTurnMulti( year: number,documents: any[], code: number, idProcedureIMP: number, idProcedureIMPDate: any, idEmployee: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "boolean_addPaymentAccountToPaymentTurn_Number_java.util.List_Number_Number_java.util.Date_Number",
      [year, documents, code, idProcedureIMP, idProcedureIMPDate, idEmployee]
    );
  }
}
